import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}goals/`;

export default {
  getAll(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },
  get(id) {
    return axios.get(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  create(data) {
    return axios.post(API_URL, data, { headers: buildHeaders() });
  },
  update(id, data) {
    return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  },
  delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  bulkDelete(ids) {
    return axios.post(`${API_URL}bulk-delete`, { ids }, { headers: buildHeaders() });
  },
};
